import React from 'react'
import { Helmet } from 'react-helmet'
import { getRouteMeta, BASE_URL } from '@/lib/routes'

interface SEOProps {
  title?: string;
  description?: string;
  type?: string;
  path: string;
}

const SEO: React.FC<SEOProps> = ({ path, title, description, type }) => {
  const routeMeta = getRouteMeta(path);
  
  const meta = {
    title: title || routeMeta?.title || 'Currents',
    description: description || routeMeta?.description,
    type: type || routeMeta?.type || 'website'
  };

  const canonicalUrl = `${BASE_URL}${path}`;

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      
      {/* OpenGraph / Facebook */}
      <meta property="og:type" content={meta.type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default SEO; 